module.exports = __webpack_public_path__ + "img/IT0004126624548.35f1e4a9.png";